// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2KlDB","location":"Header_location__3304T"};